export default "__VITE_PUBLIC_ASSET__8ae47d32__"